import React from 'react';
import './SeasonScroll.css';

interface SeasonScrollProps {
    seasons: number[];
    selectedSeason: number;
    onSeasonChange: (season: number) => void;
    isLoading?: boolean;
}

const SeasonScroll: React.FC<SeasonScrollProps> = ({ 
    seasons, 
    selectedSeason, 
    onSeasonChange, 
    isLoading = false 
}) => {
    // Sort seasons in descending order
    const sortedSeasons = [...seasons].sort((a, b) => b - a);

    return (
        <div className="navlist d-flex align-items-start mb-2">
            <div>
                <h6 className="mt-2">Sæsoner &nbsp;</h6>
            </div>
            <div className="nav nav-pills me-3 seasons-scrollable" id="v-pills-tab" role="tablist" aria-orientation="horizontal">
                {sortedSeasons.map((season) => (
                    <button
                        key={season}
                        className={`nav-link season-button ${season === selectedSeason ? 'active' : ''}`}
                        id={`v-pills-${season}-tab`}
                        data-bs-toggle="pill"
                        data-bs-target={`#v-pills-${season}`}
                        type="button"
                        role="tab"
                        aria-controls={`v-pills-${season}`}
                        aria-selected={season === selectedSeason}
                        onClick={() => onSeasonChange(season)}
                        disabled={isLoading}
                    >
                        <span className="season-number">{season}</span>
                        {isLoading && season === selectedSeason && (
                            <span 
                                className="spinner-border spinner-border-sm button-spinner" 
                                role="status" 
                                aria-hidden="true"
                            ></span>
                        )}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default SeasonScroll;